module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/117-angola-cb031424a8577cd28feacdc516484518.svg";